import React from 'react';

import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isProceedtoExecutionBlocked} from 'studies/StudyPhaseUtils';
import GenerateStudyReportButton from 'studies/workspace/overview/GenerateStudyReportButton';

import StudyExecutionHeader from '../shared/procedure-runs/overview/StudyExecutionHeader';
import {StudyOverviewTabContentsProps} from '../utils/TypedStudyTypes';
import SetClinicalStudyPhaseDropdown from './SetClinicalStudyPhaseDropdown';

export default function ClinicalStudyOverviewTabContents(props: StudyOverviewTabContentsProps): JSX.Element {
  return (
    <StudyExecutionHeader
      {...props}
      executionContainerStyling={executionContainerStyling}
      headerSectionContainerStyling={headerSectionContainerStyling}
      headerButtons={{
        buttons: (
          <>
            <GenerateStudyReportButton study={props.study} />
            <SetClinicalStudyPhaseDropdown
              study={{
                id: props.study.id,
                phase: props.study.phase,
                studyType: props.study.studySchema.studyType,
              }}
              refetch={props.refetch}
              isDisabled={
                !props.isEditable || isProceedtoExecutionBlocked(props.study.studyDesign, props.study.phase)
              }
              requiresApproval={props.isDesignApprovalRequiredToProceed}
              allowReturnToDesignPhase={props.allowReturnToDesignPhase}
              actionOrigin={ActionOrigin.STUDY_OVERVIEW_PAGE}
            />
          </>
        ),
        buttonsStyling: {display: 'flex', alignItems: 'center', gap: 8},
      }}
    />
  );
}

const executionContainerStyling: React.CSSProperties = {
  width: '100%',
  paddingLeft: 16,
  paddingRight: 16,
};

const headerSectionContainerStyling: React.CSSProperties = {
  marginLeft: 16,
  marginRight: 50,
};
